(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
  const data = window.SLDEstimatorData;
  const product = data.products.gearHammock;
  const controls = data.productControls.gearHammock;
  const sack = data.productControls.stakeSack;
  const closure = data.shared.components.sackClosure;
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const prompt = 'Select the required options above to see the estimated weight.';
  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label = String(element.labels && element.labels[0] && element.labels[0].textContent || '').replace(/\s+/g,' ').trim();
      if (!own(product.FIELD_LABELS, label)) continue;
      const field = product.FIELD_LABELS[label];
      selected[field] = own(selected, field) ? null : element.value;
    }
    for (const field of Object.values(product.FIELD_LABELS)) if (!own(selected, field)) selected[field] = null;
    return selected;
  }
  function estimate(choice) {
    if (!choice || typeof choice !== 'object') return null;
    for (const [field,values] of Object.entries(product.OPTIONS)) if (typeof choice[field] !== 'string' || !values.includes(choice[field])) return null;
    const fabric=product.FABRIC_KEYS[choice.Fabric];
    if (fabric==='manual') return {manual:true};
    const z=product.OPTIONS.Zipper.indexOf(choice.Zipper), l=product.OPTIONS.Loops.indexOf(choice.Loops), b=product.OPTIONS.Carabiners.indexOf(choice.Carabiners), s=product.OPTIONS.Suspension.indexOf(choice.Suspension);
    const body=controls.bodyLength*(z===2?controls.waterproofWidth:controls.standardWidth)*controls.densities[fabric]/1296;
    const zipper=[0,controls.zipper3,controls.zipper5][z];
    const loops=[0,controls.loopLashInches/12*controls.lashPerFoot,controls.loopRemovable,controls.loopPermanent][l];
    const carabiners=[0,controls.miniBinerEach*controls.binerCount,controls.fullBinerEach*controls.binerCount][b];
    const suspension=[0,controls.suspensionLashFeet*controls.lashPerFoot,controls.whoopiePair][s];
    const stuffSack=choice.Sack==='Yes'?controls.sack:0;
    const finished=body+zipper+loops+carabiners+suspension+stuffSack;
    return {body,zipper,loops,carabiners,suspension,stuffSack,finished,grams:finished*28.3495};
  }
  function format(result) {
    return result.finished.toFixed(2) + ' oz / ' + Math.round(result.grams) + ' g';
  }
  function start() {
    const root = document.querySelector('[data-sld-gear-hammock-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;
    const results = root.querySelector('[data-sld-estimator-results]');
    const message = root.querySelector('[data-sld-estimator-message]');
    const weight = root.querySelector('[data-sld-weight-gear-hammock]');
    function text(element,value) { if (element && element.textContent !== value) element.textContent = value; }
    function calculate() {
      const result = estimate(selections(scope));
      if (results) results.hidden = !result || !!result.manual;
      text(message,result && result.manual ? 'Custom colors require a manual weight estimate. Please contact me before ordering.' : result ? '' : prompt);
      text(weight,result && !result.manual ? format(result) : '');
    }
    let timer;
    const queue = () => { clearTimeout(timer); timer = setTimeout(calculate,75); };
    scope.addEventListener('change',queue,true);
    scope.addEventListener('input',queue,true);
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !root.contains(mutation.target))) queue();
    }).observe(scope,{subtree:true,childList:true,attributes:true,attributeFilter:['value','checked','selected']});
    calculate();
  }
  return {estimate,selections,format,start};
});

